import React from "react";

export default function IntegrationIcon({ fill }) {
  return (
    // <svg
    // 	width='31'
    // 	height='32'
    // 	viewBox='0 0 31 32'
    // 	fill='none'
    // 	xmlns='http://www.w3.org/2000/svg'
    // >
    // 	<path
    // 		d='M18.0488 23.998L13.5176 28.4727C10.6855 31.3613 5.98438 31.3613 3.15234 28.4727C0.263672 25.6406 0.263672 20.9395 3.15234 18.1074L7.62695 13.5762C7.68359 13.5195 7.74023 13.4629 7.79688 13.4062C8.25 13.0098 8.92969 13.293 8.98633 13.8594C8.98633 14.1426 8.98633 14.4258 9.04297 14.709C9.04297 14.8789 8.98633 15.1055 8.81641 15.2754C7.91016 16.1816 4.56836 19.5234 4.56836 19.5234C2.47266 21.6191 2.47266 24.9609 4.56836 27.0566C6.66406 29.1523 10.0059 29.1523 12.1016 27.0566L16.5762 22.582L16.6328 22.5254C18.6719 20.4863 18.6719 17.0879 16.5762 15.0488C16.123 14.5957 15.6133 14.1992 15.0469 13.9727C14.7637 13.8594 14.5938 13.5762 14.5938 13.293C14.6504 13.0098 14.707 12.7266 14.7637 12.4434C14.877 12.0469 15.3301 11.877 15.6699 11.9902C16.5195 12.3867 17.3125 12.8965 18.0488 13.5762C20.8809 16.4648 20.8809 21.166 18.0488 23.998ZM12.8945 18.7305C10.0625 15.8418 10.0625 11.1406 12.8945 8.30859L17.4258 3.83398C20.2578 0.945312 24.959 0.945312 27.791 3.83398C30.6797 6.66602 30.6797 11.3672 27.791 14.1992L23.3164 18.7305C23.2598 18.7871 23.2031 18.8438 23.1465 18.9004C22.6934 19.2969 22.0137 19.0137 21.957 18.4473C21.957 18.1641 21.957 17.8809 21.9004 17.5977C21.9004 17.4277 21.957 17.2012 22.127 17.0312C23.0332 16.125 26.375 12.7832 26.375 12.7832C28.4707 10.6875 28.4707 7.3457 26.375 5.25C24.2793 3.1543 20.9375 3.1543 18.8418 5.25L14.3672 9.72461L14.3105 9.78125C12.2715 11.8203 12.2715 15.2188 14.3672 17.2578C14.8203 17.7109 15.3301 18.1074 15.8965 18.334C16.1797 18.4473 16.3496 18.7305 16.3496 19.0137C16.293 19.2969 16.2363 19.5801 16.1797 19.8633C16.0664 20.2598 15.6133 20.4297 15.2734 20.3164C14.4238 19.9199 13.6309 19.4102 12.8945 18.7305Z'
    // 		fill='#575757'
    // 	/>
    // </svg>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3966 14.557C11.8505 15.1639 12.4297 15.666 13.0948 16.0294C13.7598 16.3927 14.4953 16.6088 15.2512 16.6629C16.0071 16.7171 16.7659 16.608 17.4759 16.3431C18.186 16.0783 18.8308 15.6638 19.3666 15.1278L22.5376 11.9567C23.5004 10.9599 24.0331 9.62491 24.021 8.23918C24.009 6.85344 23.4532 5.52787 22.4733 4.54797C21.4934 3.56807 20.1678 3.01224 18.782 3.0002C17.3963 2.98816 16.0613 3.52087 15.0645 4.48359L13.2464 6.2911"
        stroke={fill ? fill : "#6E6E73"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.6246 12.443C15.1707 11.8362 14.5915 11.334 13.9265 10.9707C13.2614 10.6073 12.526 10.3912 11.77 10.3371C11.0141 10.283 10.2554 10.392 9.54532 10.6569C8.83526 10.9218 8.19046 11.3363 7.65467 11.8723L4.4836 15.0433C3.52087 16.0401 2.98816 17.3751 3.0002 18.7609C3.01224 20.1466 3.56807 21.4722 4.54798 22.4521C5.52788 23.432 6.85346 23.9878 8.2392 23.9998C9.62494 24.0119 10.96 23.4792 11.9568 22.5165L13.7643 20.7089"
        stroke={fill ? fill : "#6E6E73"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
